const DummyWrap = (props) => props.component()

export default DummyWrap;
